<script>

    import { onDestroy } from 'svelte'
    import Chart from 'chart.js'
    import { toast } from 'bulma-toast'

    import GraphicsService from '../$services/graphics.service'

    import Moment from 'moment'
    import DateYearNav from '../$components/date.year.nav.svelte'
    import Spinner from '../$components/spinner.svelte'

    let dateStart = Moment().subtract(1, 'year').startOf('day').toDate()
    let dateEnd = Moment().endOf('day').toDate()

    let loading = false
    let labels = []
    let datasets = []
    let chart
    let canvas

    $: periodLabel = dateStart && dateEnd
        ? `${Moment(dateStart).format('D MMM YYYY')} – ${Moment(dateEnd).format('D MMM YYYY')}`
        : ''

    $: if (dateStart && dateEnd)
        getShipmentsMonths()

    $: labels.length && canvas && setChart()

    onDestroy(() => {
        if (chart)
            chart.destroy()
    })

    async function getShipmentsMonths() {
        if (chart) {
            chart.destroy()
            chart = null
        }

        loading = true
        labels = []
        datasets = []

        const resp = await GraphicsService.getShipmentsMonths({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
        })

        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        labels = resp.data.labels ?? []
        datasets = resp.data.datasets ?? []
    }

    function setChart() {
        const chartData = {
            labels,
            datasets: datasets.map(ds => ({
                ...ds,
                backgroundColor: 'rgba(9, 142, 55, 0.1)',
                borderColor: '#098E37',
                borderWidth: 2,
                fill: true,
                pointBackgroundColor: '#098E37',
                pointRadius: 4,
            })),
        }

        if (!chart)
            return chart = new Chart(canvas, {
                type: 'line',
                data: chartData,
                options: {
                    maintainAspectRatio: false,
                    legend: { display: false },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                precision: 0,
                            },
                        }],
                    },
                },
            })

        chart.data = chartData
        chart.update()
    }

</script>

<style>
    .graphic-card {
        background: #fff;
        border-radius: 28px;
        box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06);
        padding: 1.5rem;
        margin-bottom: 1.25rem;
        display: flex;
        flex-direction: column;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 1.25rem;
        gap: 1rem;
        box-shadow: none;
    }

    .logo {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        border: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #1a1a1a;
        font-size: 1.15rem;
        flex-shrink: 0;
    }

    .meta {
        display: flex;
        align-items: baseline;
        gap: 0.5rem;
        margin-bottom: 0.35rem;
    }

    .meta-name {
        font-weight: 700;
        color: #1a1a1a;
        font-size: 0.95rem;
    }

    .meta-date {
        color: #9e9e9e;
        font-size: 0.85rem;
    }

    .title {
        font-size: 1.5rem;
        font-weight: 700;
        color: #1a1a1a;
        line-height: 1.2;
        margin: 0 0 1.25rem;
    }

    .body {
        padding: 16px;
        border-radius: 20px;
    }

    .chart-wrap {
        position: relative;
        height: 320px;
    }

    .empty {
        color: #9e9e9e;
        font-size: 0.85rem;
        margin: 0;
        text-align: center;
        padding: 4rem 0;
    }
</style>

<div class="graphic-card">
    <div class="card-header">
        <div class="logo">
            <i class="fas fa-shipping-fast"></i>
        </div>
        <DateYearNav bind:dateStart bind:dateEnd />
    </div>

    <div class="meta">
        <span class="meta-name">Envíos</span>
        {#if periodLabel}
            <span class="meta-date">{ periodLabel }</span>
        {/if}
    </div>

    <h3 class="title">Envíos por mes</h3>

    <div class="body">
        <Spinner {loading} />
        {#if !loading && labels.length}
            <div class="chart-wrap">
                <canvas bind:this={canvas}></canvas>
            </div>
        {:else if !loading}
            <p class="empty">Sin datos en el periodo seleccionado</p>
        {/if}
    </div>
</div>
